module.exports = __webpack_public_path__ + "static/media/Fortifications.32788141.png";